import React, { useState, useEffect } from 'react';
import CryptoJS from 'crypto-js';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Form as BootstrapForm } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory, Redirect } from 'react-router-dom';
import login from '~/assets/images/Login/login.png';
import SliderImages from '~/components/layout/SliderImages';
import { aesEncrypt } from '~/utils/functions/cryptoHub';
import { getPublic } from '~/services/apiHandler';
import LogoMap from '~/assets/images/Login/meu-app-branca.png';
import LogoWhite from '~/assets/images/Login/logo-branca.png';
import register from '~/assets/images/Login/icon-register.png';
import messageMaintenance from '~/assets/images/message-tols.png';

import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';

import { AuthCodePreference } from '../../Auth/AuthCodePreference'
import { CodeSentScreen } from '../../Auth/CodeSentScreen';
import { InvalidEmail } from '../../Auth/InvalidEmail';
import { EmailRecoveryModal } from '../EmailRecoveryModal';
import { ModalExpired } from '../../../components/pages/SignIn/ModalExpired';
import { LimitAttemptsModal } from '../../Auth/LimitAttemptsModal';
import { NumberAttemptsModal } from '../../Auth/NumberAttemptsModal';
import { ErrorNotification } from '../../Auth/ErrorNotification';
import { economicGroup, userInfo } from "~/services/apiHandler";
import { getNerdMonsterLink } from "~/services/nerdmonster";


import {
  Container,
  Logo,
  LogoMobile,
  LogoMobileFooter,
  Header,
  HeaderMobile,
  FormContainer,
  LoginTitle,
  Textfield,
  SignInButton,
  ForgotPassword,
  FirstAccessContainer,
  ErrorMessage,
  LoadingIcon,
  EyeIcon,
  DivField,
  LoginBox,
  LeftContainer,
  RightContainer,
  Background,
  GradienteCenter,
  ImageCenterContainer,
  ForgotPasswordContainer,
  GradienteMobileImage,
  FormMaintenance
} from './styles';
import api from '~/services/api';
import { Creators as LoginActions } from '~/store/ducks/login';

const maintenance = false;
const BRAVIUM_INTEGRATION_ATIVO = true;

export const fetchNerdMonster = async (access_token) => {
  const header = {
    'Content-Type': 'application/json',
    access_token,
  };
  const parameters = {
    method: 'POST',
    headers: header,
  };

  try {
    // 1. Obter dados do usuário
    const userInfoResponse = await api.get('residential/store/v1/stores/me', {
      headers: header,
    });

    const userInfo = userInfoResponse.data;
    const userEmail = localStorage.getItem('email') || userInfo.email || '';

    // 2. Obter grupos econômicos para pegar addressCodes
    const economicGroupsResponse = await economicGroup({
      headers: header,
    });

    // 3. Extrair identificationCodes (addressCodes) das revendas
    const identificationCodes = [];
    const response = economicGroupsResponse.data;

    if (response && response.economicGroups && response.economicGroups.length > 0) {
      response.economicGroups.forEach(group => {
        if (group.members && group.members.length > 0) {
          group.members.forEach(member => {
            if (member.stores && member.stores.length > 0) {
              member.stores.forEach(store => {
                if (store.active && store.addressCode) {
                  identificationCodes.push(store.addressCode);
                }
              });
            }
          });
        }
      });
    } else if (response && response.headQuarter) {
      const headQuarter = response.headQuarter;
      if (headQuarter.stores && headQuarter.stores.length > 0) {
        headQuarter.stores.forEach(store => {
          if (store.active && store.addressCode) {
            identificationCodes.push(store.addressCode);
          }
        });
      }
    }

    // 4. Obter telefone do contato principal
    const contacts = userInfo.contacts || [];
    const mainContact = contacts.find(c => c.mainContact) || contacts[0];
    const cellphone = mainContact?.phone || '';

    // 5. Preparar body para POST
    const body = {
      name: localStorage.getItem('userName') || mainContact?.name || userInfo.name || '',
      email: userEmail,
      cellphone: cellphone,
      identificationCodes: identificationCodes,
    };

    // 6. Chamar POST com orquestração
    const res = await getNerdMonsterLink(body, parameters);
    const nerdMonsterUrl = res.data.nerdMonsterUrl;
    localStorage.setItem('googleMeuNegocio', nerdMonsterUrl);
  } catch (err) {
    console.error('Erro ao obter link NerdMonster:', err);
    // Não bloquear o fluxo se falhar - apenas logar o erro
  }
}

const getUserData = async (access_token) => {
  const header = {
    'Content-Type': 'application/json',
    access_token,
  };
  const parameters = {
    method: 'GET',
    headers: header,
  };
  try {
    const res = await userInfo(parameters);
    return res.data;
  } catch (err) {
    console.error('Error fetching user data:', err);
    throw err;
  }
};

const getEconomicGroupsData = async (access_token) => {
  const header = {
    'Content-Type': 'application/json',
    access_token,
  };
  const parameters = {
    method: 'GET',
    headers: header,
  };
  try {
    const res = await economicGroup(parameters);
    return res.data;
  } catch (err) {
    console.error('Error fetching economic groups:', err);
    throw err;
  }
};

const mapAddressToBraviumFormat = (address, addressId) => {
  if (!address) {
    return {
      id: addressId || '',
      streetName: '',
      number: '',
      complement: '',
      district: '',
      postalCode: '',
      city: '',
      state: '',
      country: 'BR',
    };
  }

  const postalCode = (address.zipcode || address.postalCode || address.postal_code || '')
    .replace(/\D/g, '')
    .slice(0, 8)
    .padStart(8, '0');

  return {
    id: addressId || address.id || '',
    streetName: address.address || address.street || address.streetName || '',
    number: address.addressNumber || address.number || '',
    complement: address.complement || address.addressAddition || '',
    district: address.neighborhood || address.district || '',
    postalCode: postalCode,
    city: address.city || '',
    state: address.state || address.stateAbbreviation || '',
    country: address.country || 'BR',
  };
};

const mapStoreToBraviumFormat = (store, userData) => {
  const documentNumber = (store.storeDocument || store.documentNumber || '').replace(/\D/g, '');
  const billingAddressSource =
    store.billingAddress || store.address || userData?.address || {};
  const shippingAddressSource =
    store.shippingAddress || store.address || userData?.address || {};

  const marketIdentification = userData?.microMarket || store.marketIdentification || store.market || '';
  const core = userData?.core || store.core || '';
  const ufStateRegistration = userData?.address?.stateAbbreviation || store.ufStateRegistration || store.state || '';

  const ufState = ufStateRegistration.slice(0, 2).toUpperCase();

  const storeId = store.storeId || store.id || '';
  const addressId = store.addressId || '';

  return {
    id: storeId,
    name: store.name || '',
    marketIdentification: marketIdentification,
    core: core,
    customerCode: store.customerCode || store.customerId || '',
    documentNumber: documentNumber,
    documentType: store.documentType || (documentNumber.length === 14 ? 'CNPJ' : 'CPF'),
    stateRegistration: store.stateRegistration || 'ISENTO',
    ufStateRegistration: ufState,
    billingAddress: mapAddressToBraviumFormat(
      billingAddressSource,
      billingAddressSource.id || addressId,
    ),
    shippingAddress: mapAddressToBraviumFormat(
      shippingAddressSource,
      shippingAddressSource.id || addressId,
    ),
  };
};

const getStoreUniqueKey = store => {
  const documentNumber = (
    store.storeDocument ||
    store.documentNumber ||
    ''
  ).replace(/\D/g, '');

  if (documentNumber.length === 14) {
    return `cnpj:${documentNumber}`;
  }

  const storeId = store.storeId || store.id || '';
  return `id:${storeId}`;
};

const normalizeBrPhone = raw => {
  if (!raw) return '';
  const s = String(raw).trim();
  if (s.startsWith('+')) return s;
  const d = s.replace(/\D/g, '');
  return d ? `+55${d}` : '';
};

const buildBraviumUserObject = (userData, contacts) => {
  const mainContact = contacts?.find(c => c.mainContact) || contacts?.[0];

  let userName = localStorage.getItem('userName');
  if (!userName || userName === 'undefined') {
    userName = mainContact?.name || userData?.name || '';
  }

  const userId = localStorage.getItem('userId') || userData?.id || '';

  let email = '';

  const emailContact = contacts?.find(c => c.contactType === 'EMAIL');
  if (emailContact) {
    email = emailContact?.contact || emailContact?.email || '';
  }

  if (!email || !email.includes('@')) {
    email = localStorage.getItem('email') || localStorage.getItem('userEmail') || '';
  }

  if (!email || !email.includes('@')) {
    email = userData?.email || '';
  }

  if (!email || !email.includes('@')) {
    const mainContactEmail = mainContact?.contact || mainContact?.email || '';
    if (mainContactEmail && mainContactEmail.includes('@')) {
      email = mainContactEmail;
    }
  }

  const phoneContacts = contacts?.filter(c => c.contactType === 'PHONE') || [];
  const phoneContact = phoneContacts.find(c => {
    const contact = (c.contact || '').replace(/\D/g, '');
    return contact.length === 10 && !contact.startsWith('9');
  }) || phoneContacts.find(c => {
    const contact = (c.contact || '').replace(/\D/g, '');
    return contact.length === 10;
  }) || phoneContacts[0];

  const mobileContact = phoneContacts.find(c => {
    const contact = (c.contact || '').replace(/\D/g, '');
    return contact.length === 11 || contact.startsWith('9');
  }) || phoneContacts.find(c => c !== phoneContact) || null;

  let phone = phoneContact?.contact || '';
  if (!phone) {
    phone =
      localStorage.getItem('userPhone') ||
      localStorage.getItem('consultantPhone') ||
      localStorage.getItem('cellPhoneNumber') ||
      '';
  }

  let mobile = mobileContact?.contact || '';
  if (!mobile) {
    mobile =
      localStorage.getItem('cellPhoneNumber') ||
      localStorage.getItem('userPhone') ||
      localStorage.getItem('consultantPhone') ||
      '';
  }

  const document = userData?.document || localStorage.getItem('document') || '';
  const documentNumber = document.replace(/\D/g, '');
  const documentType = documentNumber.length === 11 ? 'CPF' : 'CNPJ';

  return {
    id: userId,
    name: userName,
    email: email,
    phone: normalizeBrPhone(phone),
    mobile: '',
  };
};

const buildBraviumEconomicGroupObject = (economicGroupsData, selectedStoreId, userData) => {
  if (!economicGroupsData) return null;

  const selectedStore = selectedStoreId || localStorage.getItem('storeId') || '';

  // Formato com economicGroups (grupo econômico): economicGroups[0] + members/headQuarter
  const hasEconomicGroups =
    economicGroupsData.economicGroups && economicGroupsData.economicGroups.length > 0;

  let allStores = [];
  let economicGroupId = '';
  let economicGroupName = '';

  if (hasEconomicGroups) {
    const economicGroup = economicGroupsData.economicGroups[0];
    economicGroupName = economicGroup.name || '';

    if (economicGroup.members && economicGroup.members.length > 0) {
      economicGroup.members.forEach(member => {
        if (member.stores && member.stores.length > 0) {
          member.stores.forEach(store => {
            const storeKey = getStoreUniqueKey(store);
            if (
              store.active &&
              !allStores.find(s => getStoreUniqueKey(s) === storeKey)
            ) {
              allStores.push(store);
            }
          });
        }
      });
    }

    if (allStores.length === 0 && economicGroupsData.headQuarter?.stores) {
      economicGroupsData.headQuarter.stores.forEach(store => {
        const storeKey = getStoreUniqueKey(store);
        if (
          store.active &&
          !allStores.find(s => getStoreUniqueKey(s) === storeKey)
        ) {
          allStores.push(store);
        }
      });
    }

    if (!economicGroupName && allStores.length > 0) {
      const firstStoreWithName = allStores.find(store => store.name) || allStores[0];
      if (firstStoreWithName?.name) {
        economicGroupName = firstStoreWithName.name;
      }
    }

    economicGroupId = economicGroup?.id || '';
    if (!economicGroupId && economicGroupsData?.headQuarter?.id) {
      economicGroupId = economicGroupsData.headQuarter.id;
    }
  } else if (economicGroupsData.headQuarter?.id && economicGroupsData.headQuarter?.stores) {
    // Formato só headQuarter (sem economicGroups): montar a partir de headQuarter
    economicGroupId = economicGroupsData.headQuarter.id;
    economicGroupsData.headQuarter.stores.forEach(store => {
      const storeKey = getStoreUniqueKey(store);
      if (
        store.active &&
        !allStores.find(s => getStoreUniqueKey(s) === storeKey)
      ) {
        allStores.push(store);
      }
    });

    if (allStores.length > 0) {
      const firstStoreWithName = allStores.find(store => store.name) || allStores[0];
      if (firstStoreWithName?.name) {
        economicGroupName = firstStoreWithName.name;
      }
    }
  } else {
    return null;
  }

  const mappedStores = allStores.map(store => mapStoreToBraviumFormat(store, userData));
  const hasSelectedStoreInList = mappedStores.some(
    store => store.id === selectedStore,
  );
  const selectedStoreIdToSend =
    hasSelectedStoreInList && selectedStore
      ? selectedStore
      : mappedStores.length > 0
      ? mappedStores[0].id
      : '';

  return {
    id: economicGroupId,
    name: economicGroupName,
    selectedStoreId: selectedStoreIdToSend,
    stores: mappedStores,
  };
};

export const fetchBravium = async (access_token) => {
  try {
    const userData = await getUserData(access_token);

    const economicGroupsData = await getEconomicGroupsData(access_token);

    const contacts = userData.contacts || [];
    const braviumUser = buildBraviumUserObject(userData, contacts);

    const braviumEconomicGroup = buildBraviumEconomicGroupObject(economicGroupsData, null, userData);

    if (!braviumEconomicGroup) {
      console.error('No economic group data available');
      return;
    }

    const body = {
      user: braviumUser,
      economicGroup: braviumEconomicGroup,
    };

    const header = {
      'Content-Type': 'application/json',
      access_token,
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    await api
      .post(`residential/store/v1/users/bravium-url`, body, parameters)
      .then(res => {
        const braviumUrl = res.data.braviumUrl;
        localStorage.setItem('urlBravium', braviumUrl);
      })
      .catch(err => {
        const erro = err.response;
        console.log('erro ao obter URL Bravium:', erro);
      });
  } catch (err) {
    console.error('Error in fetchBravium:', err);
  }
};

function SingIn(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [redirectPath, setRedirectPath] = useState('/portal');

  const dispatch = useDispatch();
  const stepReducer = useSelector((state) => state.stepsReducer.step)
  const history = useHistory();

  const [loginValues, setloginValues] = useState()
  const [isModalOpenModalExpired, setIsModalOpenModalExpired] = useState(false);
  const [isModalOpenLimitAttempts, setIsModalOpenLimitAttempts] = useState(false);
  const [isModalOpenNumberAttempts, setIsModalOpenNumberAttempts] = useState(false);
  const [attempts, setAttempts] = useState(0)
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);

  useEffect(() => {
    dispatch({ type: "SET_STORES_LAPIDAR", storesLapidar: [] });
    dispatch({ type: "SET_PENDENCIESON", pendenciesOn: false });
    dispatch({
      type: "SET_PENDENCIES",
      pendencies: {
        hasPendencies: false,
        storesSelected: [],
        rules: {
          s5: true
        }
      }
    });
    dispatch({ type: 'STEP_FORGOT', step: 1 });
    const mfaHashHeader = localStorage.getItem('X-MFA-Hash');
    const savedRedirectPath = localStorage.getItem('redirectAfterLogin');
    localStorage.clear();
    if (mfaHashHeader !== null) {
        localStorage.setItem('X-MFA-Hash', mfaHashHeader);
    }
    if (savedRedirectPath) {
      localStorage.setItem('redirectAfterLogin', savedRedirectPath);
      setRedirectPath(savedRedirectPath);
    }
    return localStorage.removeItem('persist:root');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: 'RESET' });
    dispatch({ type: 'STEP', step: 1 });
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const savedRedirectPath = localStorage.getItem('redirectAfterLogin');
    if (savedRedirectPath) {
      setRedirectPath(savedRedirectPath);
    }
  }, []);

  const SigninSchema = Yup.object().shape({
    password: Yup.string()
      .required('Preencha sua senha')
      .min(8, 'Mínimo de 08 caracteres'),
    email: Yup.string()
      .email('Insira um e-mail válido')
      .required('Preencha seu e-mail'),
  });

  const getVideoToUserCod = async (userCode) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      headers: header,
    };
    let url = `/residential/ultratop/v1/usuarios/${userCode}/videos`;
    api
      .get(
        url,
        parameters,
      )
      .then((res) => {
        const videoCompliance = res.data.data.find((item) => item.video_cod === process.env.REACT_APP_COMPETITIVE_VIDEO_CODE)
        if (videoCompliance) {
          localStorage.setItem('competitiveCompliance', true);
        }
      });
  };

  const getUserByEmail = () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      headers: header,
    };
    let url = `/residential/ultratop/v1/usuarios/codigo?userEmail=${localStorage.getItem(
      'userEmail',
    )}`;
    api
      .get(url, parameters)
      .then(async res => {
        localStorage.setItem("userCod", res.data.data.user.user_cod)
        await getVideoToUserCod(res.data.data.user.user_cod);
        dispatch({ type: 'SET_USER_CODE', userCode: res.data.data.user.user_cod });
      })
      .catch(err => {
        if (err.response.status === 404) {
          const headerError = {
            'Content-Type': 'application/json',
            access_token: localStorage.getItem('access_token'),
          };
          const parametersError = {
            headers: headerError,
          };
          api
            .post(
              '/residential/ultratop/v1/usuarios',
              {
                userEmail: localStorage.getItem('userEmail'),
                resaleName: localStorage.getItem('storeName'),
                resaleSfId: localStorage.getItem('storeId')
              },
              parametersError,
            )
            .then(async res => {
              dispatch({ type: 'SET_USER_CODE', userCode: res.data.user_cod });
              await getVideoToUserCod(res.data.user_cod);
            })
            .catch(error => {
              console.error('error', error);

            });
        } else {
          toast.error(err.response.data.message);
        }
      });
  };


  const handleOpenModalModalExpired = () => {
    setIsModalOpenModalExpired(true);
  };

  const handleCloseModalModalExpired = () => {
    setIsModalOpenModalExpired(false);
  };

  const handleOpenModalLimitAttempts = () => {
    setIsModalOpenLimitAttempts(true);
  };

  const handleCloseModalLimitAttempts = () => {
    setIsModalOpenLimitAttempts(false);
  };

  const handleOpenModalNumberAttempts = () => {
    setIsModalOpenNumberAttempts(true);
  };

  const handleCloseModalNumberAttempts = () => {
    setIsModalOpenNumberAttempts(false);
  };

  async function handleGroupEconomic(access_token) {

    const header = {
      "Content-Type": "application/json",
      access_token,
    };

    const parameters = {
      method: "GET",
      headers: header,
    };

    economicGroup(parameters)
      .then(async (res) => {
        const response = res.data;
        let newStores = [];
        if (
          response &&
          response.economicGroups &&
          response.economicGroups.length > 0
        ) {
          const economicGroups = response.economicGroups;
          localStorage.setItem("groupEconomic", res.data.economicGroups[0].name)
          economicGroups.map((economicGroup) => {
            if (economicGroup.members && economicGroup.members.length > 0) {
              const members = economicGroup.members;
              members.map((member) => {
                const stores = member.stores;
                stores.map((store, index) => {
                  if (newStores.filter(newStore => newStore.storeId === store.storeId).length === 0) {
                      if (store.active) {
                          newStores.push(store);
                          dispatch({ type: "SET_STORE_ACCESS", stores: stores[0] });
                          if (localStorage.getItem("userStoreId") ===  store.storeId ||
                             (index === stores.length - 1 && localStorage.getItem('storeId') + '' === 'null' || localStorage.getItem('userId') + '' === 'undefined')) {
                              localStorage.setItem('storeId', store.storeId)
                              localStorage.setItem('storeCode', store.storeCode)
                              localStorage.setItem('storeName', store.name);
                              localStorage.setItem('storeDocument', store.storeDocument);
                                       if (localStorage.getItem("storeId") === store.storeId) {
                                  localStorage.setItem("addressId", store.addressId);
                                  localStorage.setItem("customerId", store.customerId);
                                  localStorage.setItem("organizationId", store.organizationId);
                              }
                          }
                        }
                    }
                    dispatch({ type: 'SET_STORE_ACCESS', stores: newStores });
                    return;
                });
                return;
              });
            }
          });
        } else if (response && response.headQuarter) {
          const headQuarter = response.headQuarter;
          if (headQuarter.stores && headQuarter.stores.length > 0) {

            const stores = headQuarter.stores;
            stores.map((store, index) => {
              if (newStores.filter((newStore) => newStore.storeId === store.storeId).length === 0) {
                if (store.active) {
                    newStores.push(store);
                     dispatch({ type: 'SET_STORE_ACCESS', stores: stores });
                    if (localStorage.getItem("userStoreId") ===  store.storeId ||
                    (index === stores.length - 1 && localStorage.getItem('storeId') + '' === 'null' || localStorage.getItem('userId') + '' === 'undefined')) {
                        localStorage.setItem('storeId', store.storeId)
                        localStorage.setItem('storeCode', store.storeCode)
                        localStorage.setItem('storeName', store.name);
                        localStorage.setItem('storeDocument', store.storeDocument);
                        if (localStorage.getItem("storeId") === store.storeId) {
                            localStorage.setItem("addressId", store.addressId);
                            localStorage.setItem("customerId", store.customerId);
                            localStorage.setItem("organizationId", store.organizationId);
                        }
                  }
                }
              }
              return;
            });
          }
        }
      })
      .catch((err) => {
         console.log('err', err);
      });
  }

  async function requestSignIn(values, authToken) {

    const mfaHashHeader = localStorage.getItem('X-MFA-Hash');

    localStorage.clear();
    if (mfaHashHeader !== null) {
        localStorage.setItem('X-MFA-Hash', mfaHashHeader);
    }

    dispatch({ type: "SET_INVALID_CODE", invalidCode: false });

    setLoading(true);
    const { email, password } = values;


    const header = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
      client_id: process.env.REACT_APP_CLIENT_ID,
      'X-MFA-Hash': mfaHashHeader,
      'MFA-enabled': true,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      username: email,
      password: password,
      grant_type: 'password',
      token: authToken,
    };

    try {
      const res = await api.post('residential/store/v1/users/authentications', body, parameters);
      if (res) {
        const response = res.data;

        if (response.mfa_required && response.mfa_token) {
          localStorage.setItem('mfa_token', response.mfa_token);
          localStorage.setItem('access_token', response.access_token);
          localStorage.setItem('email', email);

          const headerMFA = {
            'Content-Type': 'application/json',
            'access_token': response.access_token,
            'X-MFA-Token': response.mfa_token,
          };

          await api.get('/residential/store/v1/users/mfa-info', { headers: headerMFA })
            .then(res => {
              setLoading(false);
              if (res && res.data) {
                localStorage.setItem('userId', res.data.userId);
                dispatch({ type: "SET_USER_ID", reducerUserId: res.data.userId });
                if (res.data.contacts) {
                  localStorage.setItem('mfaContacts', JSON.stringify(res.data.contacts));
                }
                dispatch({ type: "SET_STEP", step: 1 });
              } else {
                dispatch({ type: "SET_STEP", step: 0 });
                toast.error('Usuário inválido');
              }
            })
            .catch(_ => {
              setLoading(false);
              localStorage.removeItem('mfa_token');
              toast.error('Erro ao buscar informações do usuário');
            });

          return;
        }

        localStorage.setItem('email', email);
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('refresh_token', response.refresh_token);
        const mfaHash = res.headers['x-mfa-hash'];
        if (mfaHash) {
          localStorage.setItem("X-MFA-Hash", mfaHash);
        }
        const headerAfterLogin = {
          'Content-Type': 'application/json',
          access_token: response.access_token,
        };
        const parametersAfterLogin = {
          method: 'POST',
          headers: headerAfterLogin,
        };

        await api
          .get(`/residential/store/v1/users?login=${email}&is-active=true`, parametersAfterLogin)
          .then(async res => {
            dispatch({ type: 'ORDER_DONE' });
            dispatch({ type: "RESET_NOTIFICATION" });
            dispatch({ type: "SET_USER_ID", reducerUserId: res.data[0].userId });
            localStorage.setItem('userStoreId', res.data[0].storeId)
            localStorage.setItem('userId', res.data[0].userId);
            localStorage.setItem('userEmail', email);
            if (res.data[0].privacyPolicy) {
              localStorage.setItem('privacyPolicy', res.data[0].privacyPolicy.accepted);
              localStorage.setItem('privacyPolicyFirst', res.data[0].privacyPolicy.accepted);
            } else {
              localStorage.setItem('privacyPolicy', false);
              localStorage.setItem('privacyPolicyFirst', false);
            }
            if (res.data[0].lgpd) {
              localStorage.setItem('lgpd', res.data[0].lgpd.accepted);
            } else {
              localStorage.setItem('lgpd', false);
              dispatch({ type: 'SET_MODAL_HOME', openModalHome: false });
            }
            if (res.data[0].competitiveCompliance.accepted) {
              localStorage.setItem('competitiveCompliance', res.data[0].competitiveCompliance.accepted);
            } else {
              localStorage.setItem('competitiveCompliance', false);
              await getUserByEmail();
            }
              if (res.data[0].ownerid) {
                localStorage.setItem('ownerid', res.data[0].ownerid);
              }

            handleGroupEconomic(response.access_token)

            let roles = res.data[0].roles;
            let allRoles;

            if (res.data[0].ownerid) {
              localStorage.setItem('ownerid', res.data[0].ownerid);
              dispatch({ type: 'ADD_ROLES', roles });
              const rolesHash = CryptoJS.AES.encrypt(JSON.stringify(roles), 'ultragaz-roles').toString();
              dispatch({ type: 'ADD_ROLES', roles: rolesHash });
            } else {
              await api
                .get('/residential/store/v1/roles?_limit=100', parametersAfterLogin)
                .then(res => (allRoles = res.data));
              dispatch({ type: 'ADD_ROLES', roles: allRoles });
              const rolesHash = CryptoJS.AES.encrypt(JSON.stringify(allRoles), 'ultragaz-roles').toString();
              dispatch({ type: 'ADD_ROLES', roles: rolesHash });
            }

            await api
              .get(`/residential/store/v1/users/${res.data[0].userId}/contacts?contact=${email}`, parametersAfterLogin)
              .then(async res => {
                localStorage.setItem('contactId', res.data[0].contactId);
                localStorage.setItem('contactIdSf', res.data[0].contactIdSf);
                localStorage.setItem('userName', res.data[0].name);
                await requestUserInfo(headerAfterLogin.access_token, email);
              })
              .catch(err => {});

            checkExpireAccess(headerAfterLogin.access_token, res.data[0].userId);
            dispatch({ type: "SET_STEP", step: 0 });
          })
          .catch(err => {});

        props.getEmail(email);
      } else {
        setLoading(false);
        dispatch({ type: "SET_ERROR_CREDENTIALS", errorCredentials: true });
      }
    } catch (error) {
      setLoading(false);
      dispatch({ type: "SET_ERROR_CREDENTIALS", errorCredentials: true });
      switch (error.response.data.code) {
        case '401.002': {
          dispatch({ type: "SET_STEP", step: 3 });
          break;
        }
        case '401.004': {
          handleOpenModalModalExpired();
          break;
        }
        case '401.005': {
          handleOpenModalLimitAttempts();
          break;
        }
        case '401.006':
        case '401.010': {
          const message = error.response.data.message;
          const regex = /\d+/;
          const match = message.match(regex);
          const number = parseInt(match[0], 10);
          setAttempts(number);
          handleOpenModalNumberAttempts();
          break;
        }
        case '422.002': {
          dispatch({ type: "SET_INVALID_CODE", invalidCode: true });
          dispatch({ type: "SET_STEP", step: 2 });
          break;
        }
        case '401.008': {
          localStorage.removeItem('X-MFA-Hash');
          await getUserId(email, password);
          dispatch({ type: "SET_STEP", step: 1 });
          break;
        }
        default: {
          return error.response.data.message;
        }
      }

    }
  }

  async function getUserId(email, password) {
    setLoading(true);

    const header = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
      client_id: process.env.REACT_APP_CLIENT_ID,
      'MFA-enabled': true,
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      grant_type: "password",
      username: email,
      password: password
    };

    try {
      const res = await api.post('residential/store/v1/users/authentications', body, parameters)
      if(res){
        setLoading(false);
        const response = res.data;

        if (response.mfa_token) {
          localStorage.setItem('mfa_token', response.mfa_token);
          localStorage.setItem('access_token', response.access_token);
          localStorage.setItem('email', email);

          const headerAfterLogin = {
            'Content-Type': 'application/json',
            'access_token': response.access_token,
            'X-MFA-Token': response.mfa_token,
          };

          await api
            .get(
              `/residential/store/v1/users/mfa-info`,
              { headers: headerAfterLogin }
            )
            .then(async res => {
              setLoading(false);
              if (res && res?.data) {
                 localStorage.setItem('userId', res.data.userId);
                 dispatch({ type: "SET_USER_ID", reducerUserId: res.data.userId });
                 if (res.data.contacts) {
                   localStorage.setItem('mfaContacts', JSON.stringify(res.data.contacts));
                 }
                 dispatch({ type: "SET_STEP", step: 1 });
              }  else {
                 dispatch({ type: "SET_STEP", step: 0 });
                 return toast.error('Usuário inválido')
              }
            })
            .catch(_ => {
              setLoading(false);
              localStorage.removeItem('mfa_token');
            });
        }
      } else {
        setLoading(false);
      }
     } catch (error) {
      setLoading(false);
      dispatch({ type: "SET_STEP", step: 9 });
    }
  }

  async function requestUserInfo(access_token, email) {
    dispatch({ type: "SET_ERROR_CREDENTIALS", errorCredentials: false });
    const header = {
      'Content-Type': 'application/json',
      access_token,
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    await api
      .get(`residential/store/v1/stores/me`, parameters)
      .then(res => {
        const response = res.data;
        response.contacts.map((element) => {
          if(element.mainContact) {
            localStorage.setItem('userPhone', element.phone);
          }
          return;
        });
        localStorage.setItem('userCity', response.address.city);
        localStorage.setItem('codeStore', response.codeStore);

        localStorage.setItem("userUf", response.address.stateAbbreviation);
        if (response.commercialConsultant) {
          localStorage.setItem('consultantId', response.commercialConsultant.id);
          localStorage.setItem('consultantName', response.commercialConsultant.name);
          localStorage.setItem('consultantEmail', response.commercialConsultant.email);
          localStorage.setItem('consultantPhoto', response.commercialConsultant.photo);
          if(response.commercialConsultant.phoneNumber) {
            localStorage.setItem('consultantPhone', response.commercialConsultant.phoneNumber);
          }
        }

        fetchSismakerUrl(access_token)
        fetchNerdMonster(access_token);
        if (BRAVIUM_INTEGRATION_ATIVO) {
          fetchBravium(access_token);
        }

        if(!localStorage.getItem('storeName')) {
          localStorage.setItem('storeName', response.nameStore);
        }
        toast.success('Logado com sucesso', { autoClose: 2500 });


      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
            if(err?.response?.status === 502) {
              toast.error("Ocorreu um erro");
              window.location.href = '/acessar?error';
            }
          } else {
            window.location.href = '/acessar?error';
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      })
      .finally(() => {
        handlePublic(access_token);
      });
  }

    const fetchSismakerUrl = async (access_token) => {
      const header = {
        'Content-Type': 'application/json',
        access_token,
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      await api
        .get(`residential/store/v1/stores/me/user/logged-user/sismaker-url`, parameters)
        .then(res => {
          const jobUrl =  res.data.sismakerUrl
          localStorage.setItem('jobControl', jobUrl);
        })
        .catch(err => {
          const erro = err.response;
          console.log('erro', erro);
        })
    };

  async function handlePublic(access_token) {
    const header = {
      'Content-Type': 'application/json',
      access_token,
    };
    const parameters = {
      headers: header,
    };
    // Dispatch inicial vazio para evitar undefined
    dispatch({ type: 'SET_PUBLICOS', publicos: [] });
    getPublic(parameters)
      .then(res => {
        res.data.data.map(publico => {
          publico['selected'] = false;
        });
        dispatch({ type: 'SET_PUBLICOS', publicos: res.data.data });
      })
      .catch(err => {
        console.warn('Erro ao carregar públicos:', err);
        // Dispatch vazio em caso de erro, aplicação continua funcionando
        dispatch({ type: 'SET_PUBLICOS', publicos: [] });
      });

    // Aguarda um ciclo de evento para garantir que Redux atualizou
    // Depois redireciona para o Portal
    setTimeout(() => {
      setLoading(false);
      if (access_token) setRedirect(true);
    }, 100);
  }

  async function checkExpireAccess(access_token, userId) {
    const header = {
      'Content-Type': 'application/json',
      access_token,
    };
    const parameters = {
      headers: header,
    };
    await api.get(`residential/store/v1/users/${userId}/password-expire-countdown`, parameters)
      .then(res => {
        const notify = res.data?.shouldNotify ? res.data.shouldNotify : false;
        if (notify) {
          dispatch({ type: 'PASSWORD_WILL_EXPIRE', expireInDays: res.data.countdown });
          dispatch({ type: 'DISPLAY_NOTIFY_PASSWORD', displayNotifyPassword: true });
        }
        return;
      })
      .catch(err => {})
  }

  const handleClick = (event) => {
    event.preventDefault();
    dispatch({ type: "SET_STEP", step: 10 });
    history.push('/recuperar-senha')
  };

  useEffect(()=>{
    if(stepReducer > 9) {
      dispatch({ type: "SET_STEP", step: 0 });
    }
  },[stepReducer])

  useEffect(() => {
    if (redirect) {
      const timer = setTimeout(() => {
        localStorage.removeItem('redirectAfterLogin');
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [redirect]);

  return (
    <Background>
       {isModalOpenModalExpired && <ModalExpired handleClose={handleCloseModalModalExpired} />}
       {isModalOpenLimitAttempts && <LimitAttemptsModal handleClose={handleCloseModalLimitAttempts} />}
       {isModalOpenNumberAttempts && <NumberAttemptsModal number={attempts}  handleClose={handleCloseModalNumberAttempts} />}
      <GradienteCenter/>
      <GradienteMobileImage />
      <Container>
        {redirect ? <Redirect to={redirectPath || '/portal'} /> : null}
        <LeftContainer>
          <>
            <img src={LogoWhite} alt='Ultragas'/>
          </>
        </LeftContainer>
        <ImageCenterContainer>
          <SliderImages />
        </ImageCenterContainer>
        <RightContainer>
          <LoginBox maintenance={maintenance}>
            <Header className="pt-4 pb-4">
              <Logo src={LogoMap} alt='MAP'/>
            </Header>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobile src={LogoWhite} alt='UltraGaz'/>
            </HeaderMobile>

            {stepReducer === 1 &&  <AuthCodePreference isMFA={true}/>}
            {stepReducer === 2 &&  <CodeSentScreen  handleSubmit={(authToken)=> requestSignIn(loginValues, authToken)}/>}
            {stepReducer === 9 &&  <ErrorNotification isMFA={true}/>}
            {stepReducer === 3 &&  <InvalidEmail isMFA={true} />}
            {stepReducer === 4 &&  <EmailRecoveryModal/>}

            {!maintenance && stepReducer === 0 && (
              <FormContainer>
                <LoginTitle className="mb-3">Bem vindo(a)</LoginTitle>
                <Formik
                  initialValues={{ email: '', password: '' }}
                  onSubmit={async values => {
                      setloginValues(values)
                      await requestSignIn(values);
                  }}
                  validationSchema={SigninSchema}
                >
                  {({ handleChange, handleBlur, values, errors, touched }) => (
                    <Form style={{width: '100%'}} autocomplete="off">
                      <BootstrapForm.Group controlId="email">
                        <Textfield
                          id="email"
                          type="email"
                          label="E-mail"
                          arial-label="Email"
                          aria-required
                          errorCondition={errors.email && touched.email}
                          errorMessage={errors.email}
                          title="Email"
                          onBlur={handleBlur}
                          placeholder="Email"
                          value={values.email}
                          onChange={handleChange}
                        />
                        {errors.email && touched.email ? (
                          <ErrorMessage>{errors.email}</ErrorMessage>
                        ) : null}
                      </BootstrapForm.Group>
                      <BootstrapForm.Group controlId="password">
                        <DivField
                          errorCondition={errors.password && touched.password}
                        >
                          <input
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            label="Senha"
                            arial-label="Senha"
                            aria-required
                            errorMessage={errors.password}
                            title="Senha"
                            onBlur={handleBlur}
                            placeholder="Senha"
                            value={values.password}
                            onChange={handleChange}
                            style={{
                              paddingRight: 47,
                              borderWidth: 0,
                              width: '95%',
                            }}
                          />
                          <EyeIcon
                            className={
                              showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'
                            }
                            errorCondition={errors.email && touched.email}
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        </DivField>
                        {errors.password && touched.password ? (
                          <ErrorMessage>{errors.password}</ErrorMessage>
                        ) : null}
                      </BootstrapForm.Group>
                      <ForgotPasswordContainer>
                        <ForgotPassword to="/recuperar-senha" className="mt-3" onClick={handleClick}>
                          Esqueci minha senha
                        </ForgotPassword>
                      </ForgotPasswordContainer>
                      <SignInButton
                        type="submit"
                        className="mt-4"
                        disabled={loading}
                      >
                        {loading ? (
                          <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                        ) : (
                          <>
                            <img
                              src={login}
                              style={{ width: 40, marginTop: 2 }}
                              alt="Ícone de login"
                            />
                            <span style={{paddingRight: "1.1rem", paddingTop: "7px"}}>Entrar</span>
                          </>
                        )}
                      </SignInButton>
                    </Form>
                  )}
                </Formik>

                <FirstAccessContainer
                  to="/cadastro"
                  className="mt-3 w-100"
                  onClick={() => localStorage.removeItem('persist:root')}
                >
                  <SignInButton outline disabled={loading}>
                    <>
                      <img
                        src={register}
                        style={{ width: 40, marginTop: 2 }}
                        alt="Ícone de login"
                      />
                      <span style={{paddingRight: "1.1rem", paddingTop: "7px"}}>Primeiro Acesso</span>
                    </>
                  </SignInButton>
                </FirstAccessContainer>
              </FormContainer>
            )}
            {maintenance && (
              <FormMaintenance>
                <img src={messageMaintenance} />
              </FormMaintenance>
            )}
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobileFooter src={LogoMap} alt='UltraGaz'/>
            </HeaderMobile>
          </LoginBox>
        </RightContainer>
      </Container>
    </Background>
  );
}
const mapStateToProps = state => ({
  access_token: state.loginReducer.access_token,
  refresh_token: state.loginReducer.refresh_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(LoginActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SingIn);
